module.exports = __webpack_public_path__ + "img/hsbc.5534c228.svg";